<template>
  <vs-row>
    <vs-row vs-justify="space-between">
      <h2 class="font-bold text-sm mb-1">Host/Hostess</h2>
      <vs-button
        @click="setShowAssignDropdown"
        v-if="!showAssignDropdown"
        :disabled="disableComponent"
        >Assign</vs-button
      >
    </vs-row>
    <div v-if="showAssignDropdown" class="flex w-full tablet:w-auto">
      <vs-select
        autocomplete
        label="Assign to"
        v-model="selectedHost"
      >
        <vs-select-item
          :placeholder="'Placeholder'"
          :key="'assign-host-'+booking.id+'-'+index"
          :value="host"
          :text="host.displayName"
          v-for="(host, index) in hosts"
        />
      </vs-select>
      <div class="ml-2 mt-6 flex">
      <vs-button :disabled="!selectedHost"
        @click="handleAssign" color="success" icon="done"
      ></vs-button>
      <vs-button class="ml-2"
        @click="setShowAssignDropdown" color="danger" icon="close"
      ></vs-button>
      </div>
    </div>

    <vs-row v-if="!showAssignDropdown">
      <vs-col v-if="!booking.host ">
        No host/hostess asigned to this booking.
      </vs-col>

      <vs-col v-if="booking.host">
        <vs-row>
          {{ booking.host.displayName }}
        </vs-row>
      </vs-col>
    </vs-row>
  </vs-row>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  props: {
    booking: Object,
    disableComponent: Boolean,
  },
  model: {
    prop: "booking"
      },
  data() {
    return {
      showAssignDropdown: false,
      selectedHost: ""
    };
  },
  computed: {
  ...mapGetters({
      hosts: "marcomBooking/hosts",
          }),
  },
  methods: {
      setShowAssignDropdown(){
          this.showAssignDropdown = !this.showAssignDropdown
      },
      handleAssign(){
          this.showAssignDropdown = false
          this.booking.host = this.selectedHost
      },

  }
};
</script>

<style lang="scss" scoped>
</style>
